import { ENDPOINTS } from 'config/endpoints';
import { useInfiniteQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { ResponsePaginated } from 'crono-fe-common/types/response';
import { Account } from 'crono-fe-common/types/account';
import { AccountSearch } from 'crono-fe-common/types/DTO/accountSearch';

const LIMIT = 20;

export default function useSearchAccountsInfinite(
  searchParameters: Omit<AccountSearch, 'limit' | 'offset'>,
  enabled = true,
) {
  const { selected, ...rest } = searchParameters;

  const getRequest = (offset: number): Request => ({
    url: ENDPOINTS.account.search.main,
    config: {
      method: 'post',
      data: { data: { ...rest, limit: LIMIT, offset } },
    },
  });

  return useInfiniteQuery<ResponsePaginated<Account[]>, CronoError>({
    queryKey: [ENDPOINTS.account.search.main, 'infinite', rest],
    queryFn: ({ pageParam = 0 }) => client(getRequest(pageParam as number)),
    getNextPageParam: (lastPage, pages) => {
      const loaded = pages.reduce(
        (sum, page) => sum + (page.data?.data?.length ?? 0),
        0,
      );
      const total = lastPage.data?.total ?? 0;
      if (loaded >= total) return undefined;
      return loaded;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    keepPreviousData: true,
    enabled,
  });
}
